import {groupBy, mapObject} from '@benchling/js-utils';
import {useMemo} from 'react';

import {filteredResidues} from 'molbio/proteins/AminoAcids';
import ProteinConstants, {ProteinAlignmentSLA} from 'molbio/proteins/util/ProteinConstants';

/**
 * A memoized mapping of color to what glyphs should use that color in the Protein sequence map
 * @param aminoAcids The amino acids for this slice
 * @param getColor A function that gets the intended color for a single amino acid
 */
export default function useGlyphsByColor({
  aminoAcids,
  getColor,
}: {
  aminoAcids: string;
  getColor: (aminoAcid: ProteinAlignmentSLA) => string;
}): {[color: string]: string} {
  return useMemo(() => {
    // Mapping from color to a list of individual codons / glyphs that should use that color
    const aasByColor = groupBy<ProteinAlignmentSLA, string>(
      ProteinConstants.ALIGNMENT_AMINO_ACIDS as Array<ProteinAlignmentSLA>,
      getColor
    );
    return mapObject<Array<ProteinAlignmentSLA>, string>(
      aasByColor,
      (aasOfColor: Array<ProteinAlignmentSLA>) => filteredResidues(aminoAcids, aasOfColor)
    );
  }, [aminoAcids, getColor]);
}
